export const redirectToUrlOpenNewTab = (url, base) => {
    const redirectUrl = new URL(url, base).toString();
    window.open(redirectUrl, '_blank', 'noopener, noreferrer');
};
